import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { iconFilter } from '@sorare/core/src/atoms/icons/system/iconFilter.ts';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { useFiltersCount as useBackendFiltersCount } from '@sorare/core/src/contexts/graphql-search';

export const BackendToggleFiltersButton = ({
  toggleFilters,
}: {
  toggleFilters: () => void;
}) => {
  const filtersCount = useBackendFiltersCount({
    countSealed: false,
    countQuery: false,
  });
  return (
    <Badge badgeContent={filtersCount} color="grey">
      <IconButton
        onClick={() => {
          toggleFilters();
        }}
        icon={iconFilter}
        size="small"
        color="transparent"
      />
    </Badge>
  );
};
